const diaAtual = () => {
  const dt = new Date();
  const dia = dt.getDate();
  return `${dia < 10 ? `0${dia}` : dia}`;
};

const mesAtual = () => {
  const dt = new Date();
  const mes = dt.getMonth() + 1;
  return `${mes < 10 ? `0${mes}` : mes}`;
};

const nomeDoMes = (mes: string) => {
  const meses = [
    '',
    'janeiro',
    'fevereiro',
    'março',
    'abril',
    'maio',
    'junho',
    'julho',
    'agosto',
    'setembro',
    'outubro',
    'novembro',
    'dezembro',
  ];

  return meses[parseInt(mes)];
};

const anoAtual = () => {
  const dt = new Date();
  const ano = dt.getFullYear();
  return `${ano}`;
};

const horaAtual = () => {
  const dt = new Date();
  const hora = dt.getHours();
  return `${hora < 10 ? `0${hora}` : hora}`;
};

const minutoAtual = () => {
  const dt = new Date();
  const minuto = dt.getHours();
  return `${minuto < 10 ? `0${minuto}` : minuto}`;
};

const agora = () => {
  return `${diaAtual()}-${mesAtual()}-${anoAtual()} ${horaAtual()}h${minutoAtual()}`;
};

export { mesAtual, nomeDoMes, diaAtual, anoAtual, agora };
